import { flushSync } from "react-dom";

let active: ViewTransition | undefined;
let cleanupHeading: (() => void) | undefined;

type StoryTransitionOptions = {
  afterCommit?: () => void;
  storyId?: string;
};

/** Dissolve between pages after the reader/feed scroll position has settled. */
export function storyTransition(update: () => void, options: StoryTransitionOptions = {}) {
  const headings = new Map<HTMLElement, string>();
  const markHeading = () => {
    if (!options.storyId) return false;
    const heading = [...document.querySelectorAll<HTMLElement>("[data-story-title]")].find(element => {
      const rect = element.getBoundingClientRect();
      return element.dataset.storyTitle === options.storyId && rect.width > 0 && rect.bottom > 0 && rect.top < innerHeight;
    });
    if (!heading) return false;
    headings.set(heading, heading.style.viewTransitionName);
    heading.style.viewTransitionName = "story-heading";
    return true;
  };
  let morph = false;
  const commit = () => { flushSync(update); options.afterCommit?.(); if (morph) markHeading(); };
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) { commit(); return; }
  if (!document.startViewTransition) {
    commit();
    return;
  }
  active?.skipTransition();
  cleanupHeading?.();
  morph = markHeading();
  cleanupHeading = () => { headings.forEach((value, heading) => { heading.style.viewTransitionName = value; }); headings.clear(); };
  document.documentElement.classList.add("story-page-transition");
  const transition = document.startViewTransition(commit);
  active = transition;
  void transition.finished.catch(() => {}).finally(() => {
    if (active === transition) {
      cleanupHeading?.(); cleanupHeading = undefined;
      document.documentElement.classList.remove("story-page-transition");
      active = undefined;
    }
  });
}
